import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Button, Typography, useTheme } from '@mui/material';

import { EvmTxHistory } from '@/types';
import { ShortenAddr } from '@/lib/Shorten';
import { StatusFilter } from '@/lib/filter/stakingPoolState';
import { unixToDate } from '@/lib/days';
import SymbolSvg from '@/assets/assetfi/Symbol';

const columns: GridColDef[] = [
  {
    hideable: true,
    minWidth: 200,
    flex: 1,
    field: 'from',
    headerName: 'Wallet',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <SymbolSvg width={16} height={16} />
        <Typography variant="body2" color={'#6f6f6f'}>
          {ShortenAddr(params.value)}
        </Typography>
      </Box>
    ),
  },
  {
    minWidth: 150,
    field: 'functionName',
    headerName: 'Status',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueGetter(params) {
      return StatusFilter(params.value);
    },
  },
  // {
  //   flex: 1,
  //   minWidth: 200,
  //   field: 'amount',
  //   headerName: 'Amount',
  //   headerAlign: 'center',
  //   align: 'center',
  //   sortable: false,
  // },
  {
    flex: 1,
    minWidth: 150,
    field: 'timeStamp',
    headerName: 'Date',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    valueGetter(params) {
      return unixToDate(params.value);
    },
  },
  {
    minWidth: 100,
    field: 'hash',
    headerName: 'Tx',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: (params) => (
      <Button color="primary" onClick={() => handleButtonClick(params.value)}>
        ↗
      </Button>
    ),
  },
];

const handleButtonClick = (aData: string) => {
  const src =
    process.env.NODE_ENV === 'development'
      ? `https://amoy.polygonscan.com/tx/${aData}`
      : `https://polygonscan.com/tx/${aData}`;
  window.open(src);
};
const PoolsDetailTable = ({ list }: { list: EvmTxHistory[] | null }) => {
  // theme
  const theme = useTheme();

  if (!list) {
    return;
  }

  return (
    <Box
      sx={{
        maxWidth: '1680px',
        padding: '16px 24px',
        marginTop: '16px',
        marginBottom: '38px',
      }}
    >
      <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
        Recent Activity
      </Typography>

      <Box
        sx={{
          maxHeight: 426,
          width: '100%',
          '& .MuiDataGrid-root': {
            borderRadius: '10px',
          },
          '& .MuiDataGrid-main': {
            borderRadius: '10px', // Outer border radius
          },
          '& .MuiDataGrid-columnHeaderTitleContainerContent': {
            paddingRight: '5px',
          },
          '& .MuiDataGrid-columnHeaders': {
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
          },

          '& .MuiDataGrid-virtualScroller': {
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
          },
        }}
      >
        <DataGrid
          pagination
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          autoHeight
          sx={{
            border: 'none',
            boxShadow: '0px 0px 4px 0px #00000026',
            '& .MuiDataGrid-columnHeader': {
              height: '46px !important',
              background: theme.brand.primary,
              color: '#ffffff',
              typography: 'subtitle2',
            },
            '& .MuiDataGrid-columnHeader:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-columnHeader:selected': {
              outline: 'none',
            },
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-cell': {
              typography: 'body2',
              color: theme.greyscale.grey3,
              display: 'flex',
              alignItems: 'center',
            },
          }}
          rows={list}
          columns={columns}
          getRowId={(row) => row.hash}
        />
      </Box>
    </Box>
  );
};

export default PoolsDetailTable;
